import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { BiSolidEditAlt, BiSolidTrashAlt } from 'react-icons/bi'
import { FiMoreVertical } from 'react-icons/fi'

import HoverHint from '../HoverHint'
import { TAilButtonProps } from './TailButton.types.ts'

const TailButton: React.FC<TAilButtonProps> = ({
  children,
  id,
  title,
  icon,
  setTailSelected,
  tailSelected,
  externalFunction,
  disabled = false,
  hintLabel,
  className,
  onEdit,
  onDelete
}) => {
  const [selected, setSelected] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    setSelected(id === tailSelected)
  }, [tailSelected])

  const handleClick = () => {
    if (disabled) return null
    if (setTailSelected) setTailSelected(id)
    setSelected(!selected)
  }

  const handleMouseLeave = () => {
    setMenuOpen(false)
  }

  return (
    <HoverHint hintLabel={hintLabel} ignoreStyle={true}>
      <div
        onMouseLeave={handleMouseLeave}
        onClick={!disabled && externalFunction ? externalFunction : handleClick}
        className={classNames(
          'relative flex flex-nowrap flex-col min-h-40 w-40 justify-center items-center gap-2 border-gray-300 dark:border-gray-600 rounded border-b-2',
          { 'border-green-600': selected },
          { ' dark:border-green-700 border-2 dark:border-2': selected },
          { 'cursor-not-allowed': disabled, 'cursor-pointer': !disabled },
          { 'opacity-50': disabled },
          {
            'hover:bg-gray-100 dark:hover:bg-gray-700 hover:border-b-2 hover:border-green-600 dark:hover:border-b-2 dark:hover:border-green-600':
              !disabled && !selected
          },
          className
        )}
      >
        {(onDelete || onEdit) && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation()
              setMenuOpen((prev) => !prev)
            }}
            className="absolute right-2 top-2 z-10 rounded p-1 text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-600"
            aria-label="Otwórz menu"
          >
            <FiMoreVertical size={18} />
          </button>
        )}

        {menuOpen && (
          <div
            className="absolute right-2 top-8 z-20 w-28 rounded-md border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
            onClick={(e) => e.stopPropagation()}
          >
            {onEdit && (
              <button
                type="button"
                className="block w-full px-3 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-gray-500"
                onClick={() => {
                  setMenuOpen(false)
                  onEdit?.()
                }}
              >
                <div className="flex items-center justify-center">
                  <p>Edycja</p>
                  <BiSolidEditAlt size={16} className="inline-block ml-2" />
                </div>
              </button>
            )}
            {onDelete && (
              <button
                type="button"
                className="block w-full px-3 py-2 text-left text-sm text-red-600 hover:bg-gray-100 dark:hover:bg-gray-500"
                onClick={() => {
                  setMenuOpen(false)
                  onDelete?.()
                }}
              >
                <div className="flex items-center justify-center">
                  <p>Usuń</p>
                  <BiSolidTrashAlt size={16} className="inline-block ml-2" />
                </div>
              </button>
            )}
          </div>
        )}

        {icon && <div>{icon}</div>}
        <div className="w-full px-4">
          <p
            className={classNames('text-center whitespace-normal break-words', {
              'text-green-600 font-bold': selected
            })}
          >
            {title}
          </p>
        </div>
        {children}
      </div>
    </HoverHint>
  )
}

export default TailButton
